import { createValidator, type Validator } from '@seek/validators-js';

import translations from './.vocab';

export const { noEmptyText }: { noEmptyText: Validator<string> } =
  createValidator({
    test: ({ value }: { value: string }) => Boolean(value && value.length > 0),
    formatErrorMessages:
      (messages) =>
      ({ validatorProps: { requiredLabel } }) =>
        messages['Please add...'].format({ requiredLabel }),
    translations,
    validatorName: 'noEmptyText',
  });

export const { maxLength }: { maxLength: Validator<string, { max: number }> } =
  createValidator({
    test: ({ value, validatorProps }) =>
      Boolean(value) === false ||
      (typeof value === 'string' && value.length <= validatorProps.max),
    formatErrorMessages:
      (messages) =>
      ({ validatorProps: { max } }) =>
        messages['Max characters or less'].format({ max: String(max) }),
    getInvalidText: ({ value, validatorProps: { max } }) =>
      value.length > max ? [{ start: max }] : null,
    translations,
    validatorName: 'maxLength',
  });
